export default "__VITE_ASSET__CdfKfCuE__"